module.exports = __webpack_public_path__ + "static/media/aig.2e5248d6.png";